import Swiper from 'swiper';

export default function (el, {
    progressHandle,
}) {
    new Swiper(el.querySelector('.swiper-container'), // eslint-disable-line no-new
        {
            slidesPerView: 'auto',
            threshold: 5,
            grabCursor: true,
            watchOverflow: true,
            scrollbar: {
                el: progressHandle,
                draggable: true,
            },
        });
}
